// SPDX-License-Identifier: AGPL-3.0-or-later

import {ConfirmModal} from '@app/features/app/components/dialogs/ConfirmModal';
import {useLingui} from '@lingui/react/macro';
import {observer} from 'mobx-react-lite';
export const NewAccountGuildLimitModal = observer(() => {
	const {t} = useLingui();
	return (
		<ConfirmModal
			title={t`Slow Down`}
			description={t`New accounts are limited to joining 10 communities in the first 24 hours. Please try again later.`}
			primaryText={t`Okay`}
			onPrimary={() => {}}
			secondaryText={false}
			hideCloseButton
		/>
	);
});
